import { useState, useEffect } from 'react';
import Legend from "./legend.js"
import styles from './css/weatherpanel.module.css'

export default function Weatherpanel(props) {

    const [values, setValues] = useState([0,0,0,0,0]);
    const [colors, setColors] = useState([0,0,0,0,0]);

    const [title, setTitle] = useState(styles.title);
    const [value, setValue] = useState(styles.value);
    const [unit, setUnit] = useState(styles.unit);
    
    useEffect(() => {
        if (props.point) {
            //var datetime = (props.datetime) ? props.datetime : "";
            setValues([props.point.temp.display,props.point.humi.display,props.point.wind.display,props.point.rain.display,props.point.thunder.display,props.point.seis.display])
            setColors([props.point.temp.color,props.point.humi.color,props.point.wind.color,props.point.rain.color,props.point.thunder.color,props.point.seis.color])
        }
        if (props.small) {
            setTitle(styles.title_sm);
            setValue(styles.value_sm);
            setUnit(styles.unit_sm);
        }
    }, [props.point, props.datetime]);

    return (
        <div className={styles.contents}>
            <div className={styles.item} style={{backgroundColor:colors[0]}}><span className={title}>気温</span><span className={value}>{values[0]}</span><span className={unit}>℃</span></div>
            <div className={styles.item} style={{backgroundColor:colors[1]}}><span className={title}>湿度</span><span className={value}>{values[1]}</span><span className={unit}>％</span></div>
            <div className={styles.item} style={{backgroundColor:colors[2]}}><span className={title}>風速</span><span className={value}>{values[2]}</span><span className={unit}>m/s</span></div>
            <div className={styles.item} style={{backgroundColor:colors[3]}}><span className={title}>雨量</span><span className={value}>{values[3]}</span><span className={unit}>mm/h</span></div>
            <div className={styles.item} style={{backgroundColor:colors[5]}}><span className={title}>震度</span><span className={value}>{values[5]=="-" ? "地震なし":values[5]}</span><span className={unit}></span></div>

{/*
            <div className={styles.item} style={{backgroundColor:colors[4]}}><span className={title}>雷</span><span className={value}>{values[4]}</span><span className={unit}></span></div>
*/}
{/*
            {(props.small) ?
            <div className={styles.item} style={{backgroundColor:colors[5]}}><span className={title}>震度</span><span className={value}>{values[5]}</span><span className={unit}></span></div>
                : <div className={styles.legend}><Legend/></div>
            }
*/}
        </div>
    );
}